/**
 * @cloudsam/survey-compiler
 *
 * The "designer graph → kernel descriptor" pipeline, extracted from the Survey
 * Designer so a second caller can compile a survey the same way the Designer
 * does. SuperPanel's survey import is that second caller: it reads a .cloudsam
 * file (nodes + edges, no descriptor) and has to produce exactly the descriptor
 * the Designer would have produced from the same canvas. A private copy would
 * drift, and a drifted descriptor is a survey the kernel loads differently from
 * the one the author saw — so the pipeline lives here and both apps import it.
 *
 * Plain CommonJS with no build step on purpose. Both consumers are
 * Create React App builds, which do not transpile files under node_modules;
 * ES module syntax in a `file:` dependency would therefore fail to build.
 *
 * The Designer's src/utils/<name>.js modules re-export from here, so every
 * existing designer import path (and its tests) keeps working unchanged.
 */

const { compileSurvey } = require('./compileSurvey');
const { buildDescriptorJSON, deriveMediaRefsFromDescriptor } = require('./buildDescriptorJSON');
const { buildNormalizedGraph, bfsOrder, normalizePriority, buildFlowFromGraph } = require('./graphNormalize');
const { expandPackageNodes } = require('./packageExpansion');
const { variableNameFromId, uniqueVariableName, backfillVariableNames } = require('./variableNames');
const {
  PROFILE_VERSION,
  EXECUTION_CHANNELS,
  LEGACY_EXECUTION_ALIASES,
  canonicalExecutionChannel,
  canonicalChannels,
  compileChannelDeliveryPlan,
  unresolvedDeliveryPlanItems,
} = require('./channelDeliveryPlan');

module.exports = {
  compileSurvey,
  buildDescriptorJSON,
  deriveMediaRefsFromDescriptor,
  buildNormalizedGraph,
  bfsOrder,
  normalizePriority,
  buildFlowFromGraph,
  expandPackageNodes,
  variableNameFromId,
  uniqueVariableName,
  backfillVariableNames,
  PROFILE_VERSION,
  EXECUTION_CHANNELS,
  LEGACY_EXECUTION_ALIASES,
  canonicalExecutionChannel,
  canonicalChannels,
  compileChannelDeliveryPlan,
  unresolvedDeliveryPlanItems,
};
